import { Reveal, SectionHead } from "./shared";
import { IMAGES } from "../data/content";

const ROLES = ["Engineers", "Supervisors", "Technicians", "Field Teams", "Project Coordination", "Safety Awareness"];

export const People = () => (
    <section data-testid="people-section" className="relative bg-white py-16 lg:py-32">
        <div className="vec-container">
            <SectionHead
                index="SEC 11"
                eyebrow="People"
                title="People Behind the Infrastructure"
                sub="VEC is an execution company powered by people — engineers, supervisors, technicians and field teams working together on critical power infrastructure."
            />

            <div className="mt-12 grid grid-cols-12 gap-6 lg:gap-8">
                <div className="col-span-12 md:col-span-7">
                    <Reveal>
                        <div className="group tech-frame relative overflow-hidden border border-vec-border aspect-[16/10]">
                            <img
                                src={IMAGES.peopleA}
                                alt="Technicians installing solar infrastructure at a project site"
                                loading="lazy"
                                className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                            />
                            <span className="absolute bottom-3 left-3 bg-vec-charcoal/85 text-white font-mono-tech text-[9px] uppercase tracking-[0.2em] px-3 py-1.5">
                                Team photography to be updated
                            </span>
                        </div>
                    </Reveal>
                </div>
                <div className="col-span-12 md:col-span-5">
                    <Reveal delay={0.1}>
                        <div className="group tech-frame relative overflow-hidden border border-vec-border aspect-[16/10] md:aspect-auto md:h-full">
                            <img
                                src={IMAGES.peopleB}
                                alt="Solar array infrastructure at a project location"
                                loading="lazy"
                                className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                            />
                        </div>
                    </Reveal>
                </div>
            </div>

            <div className="mt-8 flex flex-wrap gap-x-8 gap-y-3 border-t border-vec-border pt-6">
                {ROLES.map((r) => (
                    <span key={r} className="flex items-center gap-2 font-mono-tech text-[11px] uppercase tracking-[0.2em] text-vec-charcoal/60">
                        <span className="h-1 w-1 rotate-45 bg-vec-green" aria-hidden="true" />
                        {r}
                    </span>
                ))}
            </div>
        </div>
    </section>
);
